<template>
    <div>
        <app-overlay-loader v-if="preloader"/>
        <form v-else
            ref="form"
            method="post"
            :data-url="`${TENANT_BASE_URL}general/settings/job-banner`"
            @submit.prevent="submitData"
            enctype="multipart/form-data"
            class="mb-0"
            :class="{'loading-opacity': preloader}">

            <div class="form-group row">
                <label class="col-lg-3 col-xl-3 mb-lg-0">
                    {{ $t('job_list_banner') }}<br>
                    <small class="text-muted font-italic">
                        {{ $t('recommended_company_banner_size') }}
                    </small>
                </label>
                <div class="col-lg-8 col-xl-8">
                    <app-input
                        v-if="imageUploaderBoot"
                        type="custom-file-upload"
                        :generate-file-url="false"
                        v-model="image.job_list_banner"
                        :label="$t('change_banner')"
                        :error-message="$errorMessage(errors, 'job_list_banner')"
                    />
                </div>
            </div>

            <div class="form-group row">
                <label class="col-lg-3 col-xl-3 mb-lg-0">
                    {{ $t('job_detail_banner') }}<br>
                    <small class="text-muted font-italic">
                        {{ $t('recommended_company_banner_size') }}
                    </small>
                </label>
                <div class="col-lg-8 col-xl-8">
                    <app-input
                        v-if="imageUploaderBoot"
                        type="custom-file-upload"
                        :generate-file-url="false"
                        v-model="image.job_detail_banner"
                        :label="$t('change_banner')"
                        :error-message="$errorMessage(errors, 'job_detail_banner')"
                    />
                </div>
            </div>

            <div class="mt-5">
                <app-submit-button :loading="loading" @click="submitData"/>
            </div>
        </form>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {formDataAssigner} from '../../../../../common/Helper/Support/FormHelper'
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins"
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : 'JobBannerSettings',
    mixins: [FormHelperMixins],
    data() {
        return {
            TENANT_BASE_URL,
            settings         : {},
            image            : {
                job_list_banner  : '',
                job_detail_banner: '',
            },
            imageUploaderBoot: false
        }
    },
    methods : {
        beforeSubmit() {
            this.preloader = true;
            this.loading   = true;
            this.message   = '';
            this.errors    = {};
        },
        submitData() {
            let formData = formDataAssigner(new FormData, this.settings);
            Object.keys(this.image).forEach(key => {
                if (this.image[key] && this.image[key] instanceof File) {
                    formData.append(key, this.image[key]);
                }
            })
            return this.save(formData);
        },
        afterSuccess({data}) {
            this.toastAndReload(data.message);
            location.reload();
        },
        ...mapActions([
            'getConfig',
            'getTenantSettings'
        ]),
    },
    computed: {
        ...mapState({
            languages      : state => state.support.languages,
            generalSettings: state => state.tenant_settings.tenantSettings
        }),
        tenant() {
            return window.tenant;
        },
    },
    created() {
        this.getConfig();
        this.getTenantSettings();
        this.preloader = true;
    },
    watch: {
        generalSettings: {
            handler: function (settings) {
                if (!Object.keys(this.settings).length) {
                    this.image             = {
                        job_list_banner  : settings.job_list_banner ? urlGenerator(settings.job_list_banner) : urlGenerator('/images/default_banner.jpg'),
                        job_detail_banner: settings.job_detail_banner ? urlGenerator(settings.job_detail_banner) : urlGenerator('/images/default_banner.jpg')
                    }
                    this.preloader         = false;
                    this.imageUploaderBoot = true;
                }
            },
            deep   : true
        }
    },

}
</script>